<template>
  <div class="source-container" style="height:100%;overflow:hidden;">
    <div id="selected" class="source-column">
      <header>
        <h4>Selected Boxes</h4>
        <a href="#" @click="isSearchActive= !isSearchActive">Search ...</a>
      </header>
      <ul v-if="Object.keys(selectedBoxes).length>0">
        <li :class="['box-source']" v-for="box in (selectedBoxes || {})" :key="box.uid">
          <i class="fas fa-trash" @click.prevent="toggleBox(box)"></i>
          <span>
            {{box.name}}
            <br />
            <span class="station-label">({{(box.station || {}).name}})</span>
          </span>
        </li>
      </ul>
      <div v-else class="empty">
        <div class="text">Nothing selected...</div>
        <div>
          <button href="#" @click="isSearchActive= !isSearchActive">Search ...</button>
        </div>
      </div>
    </div>
    <div class="search-container" v-if="isSearchActive">
      <header>
        <h4>Search for sources</h4>
        <a href="#" @click="isSearchActive= !isSearchActive">
          <i class="fa fa-times" />
        </a>
      </header>
      <div class="search-content">
        <div id="station-source" class="source-column">
          <ul>
            <li class="header">
              <h4>Stations</h4>
            </li>
            <li :class="['station-source', {'active':activeStation && activeStation.uid == station.uid}]" v-for="station in (stations || []).items" :key="station.uid" @click.prevent="activateStation(station)" >
              <span>{{station.name}}</span>
            </li>
          </ul>
        </div>
        <div id="box-source" class="source-column">
          <ul v-if="activeStation">
            <li class="header">
              <h4>Boxes</h4>
            </li>
            <li
              :class="['box-source', {'active':(selectedBoxes[box.uid]||{}).uid == box.uid}]"
              v-for="box in stationMusicBoxes"
              :key="box.uid"
              @click.prevent="toggleBox(box)"
            >
              <span>
                <i class="fas fa-check"></i>
                {{box.name}}
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.empty {
  text-align: center;
  margin: 50px 10px;
}
.empty .text {
  margin: 0 0px 25px 0;
}
h4 {
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.7px;
  line-height: 1;
  margin:0;padding:0;
}
.source-container {
  display: flex;
  flex-direction: row;
  height: 100%;
}

.search-container {
  overflow: hidden;
  height: 100%;
  display:flex;
  flex-direction:column;
  margin-left: 10px;
  flex-grow: 1;
  justify-content: stretch;
}
#selected.source-column {
  height: 100%;
  width: 350px;
  max-width: 400px;
}

.search-container .search-content {
  display: flex;
  flex-grow: 1;
  flex-direction: row;
  height:100%;
}
#station-source.source-column,
#box-source.source-column {
    height: 100%;overflow: auto;
}
#station-source.source-column li.header,
#box-source.source-column li.header
{
    position:sticky;
    top:0;
    background:white;
    z-index:100;
}
#station-source.source-column {
  flex-grow: 0.25;
}
#box-source.source-column {
  flex-grow: 1;
}
.search-container header,
.source-column header {
  display: flex;
  justify-content: space-between;
  align-content: center;
  align-items: center;
  padding: 10px 15px;
  border-bottom: var(--COLOR_BORDERS) 1px solid;
}
.search-container header h4,
.source-column header h4 {
  margin: 0;
}
.source-column li i {
  margin-right: 15px;
}
.source-column li i:hover {
  margin-right: 15px;
  color: var(--COLOR_BRAND);
}
.source-column li {
  height: auto;
  padding: 5px 15px 5px 15px;
  align-items: baseline;
}
.source-column li .station-label {
  font-size: 12px;
  font-weight: 600;
}
.source-column li i.fa-check {
  opacity: 0.1;
  transition: color 0.2s ease-in-out;
}
.source-column li.active i.fa-check {
  opacity: 1;
  color: var(--COLOR_BRAND);
}
</style>

<script>
import { HTTP } from "@/utils/http";
import Apis from "@/apis/index";
import Constants from "@/store/constants";
export default {
  mounted() {
    this.loadStations();
  },
  data() {
    return {
      isSearchActive: false,
      activeStation: null,
      stations: [],
      stationBoxes: {},
      selectedBoxes: {}
    };
  },
  computed: {
    stationMusicBoxes() {
      if (!this.activeStation) return [];
      if (!this.stationBoxes) return [];
      // allow only music boxes
      return ((this.stationBoxes[this.activeStation.uid] || {}).items || [])
        .filter(
          itm =>
            (itm.type === Constants.boxTypes.BOX.key ||
              itm.type === Constants.boxTypes.BOX.value) &&
            (itm.trackType === Constants.trackTypes.MUSIC.key ||
              itm.trackType === Constants.trackTypes.MUSIC.value)
        )
        .sort(function(a, b) {
          return (a.name || "").localeCompare(b.name);
        });
    }
  },
  methods: {
    // Load Stations
    async loadStations() {
      var response = await HTTP.get(Apis.station.list);
      console.log(response);
      if (response.data.dataItem) {
        this.stations = response.data.dataItem;
        if (this.stations.items && this.stations.items.length > 0)
          this.activateStation(this.stations.items[0]);
      }
    },
    // Load StationBox
    activateStation(station) {
      this.activeStation = station;
      this.loadStationsBox(station.uid);
    },
    toggleBox(box) {
      if (this.selectedBoxes[box.uid]) {
        this.$set(this.selectedBoxes, box.uid, null);
        delete this.selectedBoxes[box.uid];
      } else {
        box.station = this.activeStation;
        this.$set(this.selectedBoxes, box.uid, box);
      }
    },
    async loadStationsBox(stationUid) {
      var response = await HTTP.get(Apis.boxes.search, {
        params: {
          radiouid: stationUid,
          sortField: "name",
          sortAscending: true,
          pageSize: 0,
          page: 0
        }
      });

      if (response.data.dataItem) {
        this.$set(this.stationBoxes, stationUid, response.data.dataItem);
      }
      console.log(
        "      loaded Station boxes : ",
        this.stationBoxes[stationUid]
      );
    }
  }
};
</script>
